import React from 'react'
import styled from 'styled-components'
import { Box } from 'rebass'
import media from '../../../utils/style'
import AutomotiveCard from './AutomotiveCard'
import buildImageUrl from '../../../../lib/media-url-maker'

const Title = styled.h2`
  margin: 0;
  font-size: 1.25rem;
  padding-bottom: 24px;

  ${media.MediumScreenUp`
    padding-bottom: 32px;
  `}
`

const Container = styled(Box)`
  width: 100%;
  max-width: 1210px;
  padding: 40px 20px 50px;
  margin-left: auto;
  margin-right: auto;

  ${media.MediumScreenUp`
    padding: 50px 32px 60px;
  `}

  ${media.LargeScreenUp`
    padding: 70px 32px 90px;
  `}
`

const CardContainer = styled(Box)`
  display: grid;
  flex-wrap: wrap;
  gap: 12px;

  ${media.MediumScreenUp`
    grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
    gap: 24px;
  `}

  ${media.LargeScreenUp`
    gap: 30px;
  `}
`

const getImage = (item) =>
  item.images &&
  item.images.widgets &&
  item.images.widgets[0] &&
  item.images.widgets[0].crops &&
  item.images.widgets[0].crops[0] &&
  item.images.widgets[0].crops[0].src

const AutomotiveCardsWidget = ({ title, items }) => {
  return (
    <Container>
      <Title>{title}</Title>
      <CardContainer>
        {items.map((item) => (
          <AutomotiveCard
            key={item.link}
            title={item.title}
            theme="blue"
            href={item.link}
            backgroundColor={item.backgroundColor}
            textColor={item.textColor}
            image={buildImageUrl({
              width: 600,
              resource: getImage(item)
            })}
          />
        ))}
      </CardContainer>
    </Container>
  )
}

export default AutomotiveCardsWidget
